import React, { useMemo, useState } from 'react'
import { Button, InputGroup, InputGroupAddon, Spinner, Alert } from 'reactstrap'
import { AlertCircle } from 'react-feather'
import { isBefore } from 'date-fns'
import { FormattedMessage } from 'react-intl'

import { Separator, Show } from '~/components/commons'
import DateTimePicker from '~/components/DateTimePicker'
import styled from 'styled-components'
import { useFormikContext } from 'formik'

function ScheduleSubmitForm({ loading, initialDate }) {
  const { setFieldValue } = useFormikContext()
  const [datetimeSchedule, setDatetimeSchedule] = useState(initialDate)

  const isScheduleInvalid = useMemo(
    () => !!datetimeSchedule && isBefore(datetimeSchedule, new Date()),
    [datetimeSchedule]
  )

  function setFormikValue(value) {
    setFieldValue('schedulePost', value, false)
  }

  function handleChangeSchedule(date) {
    const selected = date?.[0]
    if (!selected) return
    setDatetimeSchedule(selected)
    setFormikValue(selected?.getTime())
  }

  function resetSchedule() {
    setDatetimeSchedule('')
    setFieldValue('schedulePost', null)
  }

  return (
    <ScheduleSubmitForm.Container>
      <label className="font-medium-1 text-bold-500" htmlFor="schedule-date">
        <FormattedMessage id="Schedule to" />:
      </label>
      <InputGroup style={{ flexWrap: 'nowrap' }}>
        <DateTimePicker
          id="schedule-date"
          style={{
            display: 'flex',
            flex: 1,
          }}
          showIcon
          value={datetimeSchedule}
          onChange={handleChangeSchedule}
          invalid={isScheduleInvalid}
          minuteIncrement={5}
          options={{
            mode: 'single',
          }}
          data-enable-time
        />
        <InputGroupAddon addonType="append">
          <Button
            style={{ zIndex: 0 }}
            onClick={resetSchedule}
            type="button"
            color="warning"
          >
            <FormattedMessage id="Clear" />
          </Button>
        </InputGroupAddon>
      </InputGroup>
      <Alert className="mt-1" color="danger" isOpen={isScheduleInvalid}>
        <AlertCircle size={15} />{' '}
        <span>
          <FormattedMessage id="You can only schedule a post to happen in the future" />
        </span>
      </Alert>

      <Show condition={!!datetimeSchedule}>
        <Button
          type="submit"
          color="info"
          size="lg"
          className="text-bold-600 font-medium-1 mt-2 text-uppercase"
          block
          disabled={isScheduleInvalid || loading}
        >
          {loading && <Spinner color="white" size="sm" />}
          <FormattedMessage id="Preview & Schedule" />
        </Button>
      </Show>
      <Show condition={!datetimeSchedule}>
        <Separator className="my-2 text-uppercase">
          <FormattedMessage id="Or" />
        </Separator>

        <Button
          type="submit"
          color="success"
          size="lg"
          className="text-bold-600 font-medium-1 text-uppercase"
          block
          disabled={loading}
        >
          {loading && <Spinner color="white" size="sm" />}
          <FormattedMessage id="Preview & Publish" />
        </Button>
      </Show>
    </ScheduleSubmitForm.Container>
  )
}

ScheduleSubmitForm.Container = styled.div`
  margin-top: 2em;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`

export default ScheduleSubmitForm
